import React from 'react';

export const AccordionContext = React.createContext({
	expandedId: null,
	setExpandedId: id => {},
	scrollableContainer: null,
});
